export default "__VITE_ASSET__rHfonOWS__"